<div class="relative block" [class.animate-pulse]="loading()">
    @for (key of [dropdownRenderKey()]; track key) {
        <sh-dropdown
            #dropdown
            [label]="label()"
            [disabled]="loading() || disabled() || isDisabled()"
            [hint]="hint()"
            [attr.multi-select]="multiSelect() ? true : null"
            [attr.mandatory]="mandatory() ? true : null"
            [attr.condensed]="condensed() ? true : null"
            [attr.error]="error() ? true : null"
            [attr.error-message]="errorMessage()"
            [attr.editable]="searchable() && !useExternalSearch() ? true : null"
            [attr.no-border]="noBorder() ? true : null"
            [attr.readonly]="readOnly() ? true : null"
            display="label"
            [class]="class()"
            (clear-clicked)="handleClear()"
        >
            @if (useExternalSearch()) {
                <div class="select-panel">
                    <div class="select-search" (click)="$event.stopPropagation()">
                        <div class="flex items-center gap-1 py-2">
                            <sh-search
                                type="text"
                                [label]="'common.general.search' | translate"
                                condensed
                                [value]="searchQuery()"
                                (input)="onSearchInput($event)"
                                (keydown)="$event.stopPropagation()"
                                placeholder="Search…"
                                no-border
                            />
                            @if (searchQuery()) {
                                <sh-icon button icon="cancel" size="xs" (click)="clearSearch()"></sh-icon>
                            }
                        </div>
                    </div>
                    <div class="select-options">
                        @for (option of visibleOptions(); track option.value + '|' + option.label) {
                            <sh-menu-item
                                [attr.data-testid]="optionTestId() ? optionTestId() + '-' + option.value : null"
                                [label]="option.label | translate"
                                [value]="option.value"
                                [disabled]="option.disabled || false"
                                [active]="isOptionActive(option.value)"
                                checkbox
                                (click)="handleMenuItemClick(option.value)"
                            ></sh-menu-item>
                        }
                    </div>
                </div>
            } @else {
                @for (option of visibleOptions(); track option.value + '|' + option.label) {
                    <sh-menu-item
                        [attr.data-testid]="optionTestId() ? optionTestId() + '-' + option.value : null"
                        [label]="option.label | translate"
                        [value]="option.value"
                        [disabled]="option.disabled || false"
                        [active]="isOptionActive(option.value)"
                        (click)="handleMenuItemClick(option.value)"
                    ></sh-menu-item>
                }
            }
        </sh-dropdown>
    }
</div>
